<template>
    <div class="designers">

        <v-row>
            <v-col class="text-right">
                <router-link to="/custom" class="not-text-decoration">
                    <v-icon large color="">mdi-close</v-icon>
                </router-link>
            </v-col>
        </v-row>

        <v-row class="pt-6">

            <v-col cols="4" v-for="(designer, d) in designers" :key="'dddd'+d" class="text-center designerCol" v-bind:class="{'designerOpac': active != -1 && active != d}" @mouseover="active = d;" @mouseleave="active = -1">
                <router-link :to="'/custom/designers/'+designer.url">
                    <v-img :src="'https://artlesscms.actstudio.xyz'+designer.logo.path" class="mx-auto" max-width="270"></v-img>
                </router-link>

                <router-link :to="'/custom/designers/'+designer.url" class="not-text-decoration">
                    <span class="d-block bold">{{designer.name}}</span>
                    <!-- <span class="d-block">{{designer.category}}</span> -->
                </router-link>
                
            </v-col>
        </v-row>
    </div>
</template>

<script>
import goTo from 'vuetify/es5/services/goto'
export default {
    data(){
        return {
            designers: [],
            active: -1
        }
    },
    beforeMount: function () {
        var aux = this;
        fetch(
            "https://www.artlesscms.actstudio.xyz/api/collections/get/Designers?token=a15be93e9cdb43ca2b3778c2077c26",
            {
                method: "post",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    sort: {_o:1},
                })
            }
        )
        .then(res => res.json())
        .then(res => (this.designers = res.entries))
        .then(res => goTo('#designers'));
    },
    mounted: function(){
        this.$emit("update", 2);
        goTo('#designers');
        gtag('config', 'UA-26953667-1', {
        'page_title' : 'Custom Designers',
        'page_path': '/custom/designers/'
        });
    }
}
</script>